import React from "react";

/* eslint-disable max-len */
function VideoUploadIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={100} height={80} viewBox="0 0 100 80">
            <defs>
                <style>{".e{fill:#fff}"}</style>
                <clipPath id="a">
                    <path d="M100 80H0V0h95a4.951 4.951 0 015 5z" />
                </clipPath>
            </defs>
            <g clipPath="url(#a)">
                <path
                    d="M69.6 25.1L100 65.4V0H5a4.951 4.951 0 00-5 5v70a4.951 4.951 0 005 5h44.3L29.7 54z"
                    fill="#da5b56"
                />
                <path
                    d="M100 65.4L69.6 25.1 29.7 54l19.6 26H95a4.951 4.951 0 005-5z"
                    fill="#b84f4b"
                />
            </g>
            <path
                d="M67.9 55.7H32.1a2.946 2.946 0 01-3-3V27.8a2.946 2.946 0 013-3h35.7a2.946 2.946 0 013 3v24.9a2.865 2.865 0 01-2.9 3z"
                fill="#5b574c"
            />
            <path
                className="e"
                d="M34 30.3h-.8a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.415 1.415 0 01-1.5 1.5zM40.6 30.3h-.8a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.538 1.538 0 01-1.5 1.5zM47.1 30.3h-.8a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.473 1.473 0 01-1.5 1.5zM53.7 30.3h-.8a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.538 1.538 0 01-1.5 1.5zM60.2 30.3h-.8a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.538 1.538 0 01-1.5 1.5zM66.7 30.3H66a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.561 1.561 0 01-1.6 1.5zM34 53.1h-.8a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.415 1.415 0 01-1.5 1.5zM40.6 53.1h-.8a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.538 1.538 0 01-1.5 1.5zM47.1 53.1h-.8a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.473 1.473 0 01-1.5 1.5zM53.7 53.1h-.8a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.538 1.538 0 01-1.5 1.5zM60.2 53.1h-.8a1.538 1.538 0 01-1.5-1.5v-.1a1.538 1.538 0 011.5-1.5h.8a1.538 1.538 0 011.5 1.5v.1a1.538 1.538 0 01-1.5 1.5zM66.7 53.1H66a1.538 1.538 0 01-1.5-1.5v-.1A1.538 1.538 0 0166 50h.8a1.538 1.538 0 011.5 1.5v.1a1.561 1.561 0 01-1.6 1.5z"
            />
        </svg>
    );
}

export default VideoUploadIcon;
